declare global {
  interface Window {
    clarity?: (...args: unknown[]) => void;
  }
}

type ClarityFunction = ((...args: unknown[]) => void) & {
  q?: unknown[][];
};

export const initializeClarity = (projectId?: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!projectId || window.clarity) {
    return;
  }

  const clarity: ClarityFunction = function (...args: unknown[]) {
    (clarity.q = clarity.q || []).push(args);
  };

  window.clarity = clarity;

  const scriptTag = document.createElement('script');
  scriptTag.async = true;
  scriptTag.src = `https://www.clarity.ms/tag/${projectId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript?.parentNode?.insertBefore(scriptTag, firstScript);
};

export {};

